import React from "react"
import { Paper, Box, Typography, useTheme } from "@mui/material"
import SoundButton from "components/Activity/SoundButton"
import { useThemeContext } from "contexts/ThemeContext"

const getArrowStyles = (direction, borderColor, backgroundColor) => {
  const size = 12
  const thickness = 1

  const base = {
    position: "absolute",
    width: size,
    height: size,
    backgroundColor,
    border: `${thickness}px solid ${borderColor}`,
    transformOrigin: "center",
    zIndex: 10,
  }

  switch (direction) {
    case "top":
      return {
        ...base,
        top: -size / 2,
        left: 24,
        transform: "rotate(45deg)",
        borderBottomColor: "transparent",
        borderRightColor: "transparent",
      }
    case "bottom":
      return {
        ...base,
        bottom: -size / 2,
        left: 24,
        transform: "rotate(225deg)",
        borderBottomColor: "transparent",
        borderRightColor: "transparent",
      }
    case "left":
      return {
        ...base,
        left: -size / 2,
        top: 24,
        transform: "rotate(135deg)",
        borderTopColor: "transparent",
        borderLeftColor: "transparent",
      }
    case "right":
      return {
        ...base,
        right: -size / 2,
        top: 24,
        transform: "rotate(-45deg)",
        borderTopColor: "transparent",
        borderLeftColor: "transparent",
      }
    default:
      return {}
  }
}

const ThinkingBubble = ({
  children,
  arrowDirection = "bottom",
  backgroundColor = "#fff",
  icon = null,
  maxWidth = 400,
  textAlign = "left",
  containerComponent = "p",
  paperSx = {},
  sound = {
    uri: null,
    transcription: null,
    lang: "en-US",
  },
  hideSoundButton = false,
}) => {
  // const { textEditorSettings } = useAuthContext()
  // const [textFontSize, setTextFontSize] = useState()
  // const [textFontStyle, setTextFontStyle] = useState()
  // const [bgColor, setBgColor] = useState()
  const {
    bgColor,
    fontSize: textFontSize,
    fontFamily: textFontStyle,
  } = useThemeContext()
  const theme = useTheme()

  // useEffect(() => {
  //   if (textEditorSettings?.fontSize >= 0) {
  //     const selectedFontSize = fontOptions[textEditorSettings?.fontSize]
  //     if (selectedFontSize) {
  //       setTextFontSize(selectedFontSize.fontSize)
  //     }
  //   }
  //   if (textEditorSettings?.backgroundColor >= 0) {
  //     const selectedBgColor = bgOptions[textEditorSettings?.backgroundColor]
  //     if (selectedBgColor) {
  //       setBgColor(selectedBgColor.bg)
  //     }
  //   }
  //   if (textEditorSettings?.fontFamily >= 0) {
  //     const selectedFontFamily =
  //       fontFamilyOptions[textEditorSettings?.fontFamily]
  //     setTextFontStyle(selectedFontFamily?.name || fontFamilyOptions[0].name)
  //   }
  // }, [textEditorSettings])

  return (
    <Box sx={{ position: "relative", maxWidth }}>
      <Paper
        elevation={0}
        sx={[
          {
            display: "flex",
            alignItems: "safe center",
            p: 2,
            borderRadius: "15px",
            border: `1px solid ${theme.palette.primary.main}`,
            backgroundColor,
            position: "relative",
            zIndex: 1,
            gap: 1,
            maxHeight: "50vh",
            overflow: "auto",
            ...paperSx,
          },
          bgColor && { backgroundColor: bgColor },
        ]}
      >
        {sound?.uri !== null && !hideSoundButton && (
          <SoundButton
            size="small"
            soundTranscription={sound?.transcription}
            soundUrl={sound?.uri}
            speechOptions={{ lang: sound?.lang || "en-US" }}
            autoPlay={false}
          />
        )}
        {icon && <Box sx={{ mr: 1 }}>{icon}</Box>}
        <Typography
          variant="body1"
          component={containerComponent}
          textAlign={textAlign}
          sx={[
            {
              fontSize: textFontSize,
              fontFamily: textFontStyle,
              "& span": {
                fontSize: textFontSize,
                fontFamily: textFontStyle,
              },
              "& .title": {
                fontWeight: "bold",
                fontSize: textFontSize
                  ? typeof textFontSize === "string"
                    ? parseInt(textFontSize?.replace("px", "")) + 4
                    : textFontSize + 4
                  : 22,
              },
              "& div": {
                fontSize: textFontSize,
                fontFamily: textFontStyle,
              },
            },
          ]}
        >
          {children}
        </Typography>
      </Paper>

      {/* Flecha rectangular con borde */}
      <Box
        sx={getArrowStyles(
          arrowDirection,
          theme.palette.primary.main,
          bgColor || backgroundColor
        )}
      />
    </Box>
  )
}

export default ThinkingBubble
